<template>
  <header class="vxdash-top-nav">
    <a class="vxdash-logo" href="index.php">
        <b>GTA</b> Admin
    </a>
    <nav class="vxdash-navbar float-wrap" role="navigation">
        <!-- Sidebar toggle button-->
        <a href="#" @click="changeState" class="vxdash-sidebar-toggle" role="button">
          <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
            <path d="M4 18H10" stroke="#ffffff" stroke-width="2" stroke-linecap="round"/>
            <path d="M4 12L16 12" stroke="#ffffff" stroke-width="2" stroke-linecap="round"/>
            <path d="M4 6L20 6" stroke="#ffffff" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </a>
        <div class="vxdash-navbar-custom-menu">
        </div>
    </nav>
</header>

<div class="vx-xwrap">
    <section :class="{'mobile vxdash-mobile' : state.mobile}" class="vxdash-side-nav" id="vxdash-sidebar">
        <div class="vxdash-side-user-panel  float-wrap">
            <div class="vxdash-side-user-panel-userimg">
                <img src="@/assets/img/dp.jpg" class="vxdash-user-image" alt="User Image"/>
            </div>
            <div class="vxdash-side-user-panel-userinfo">
                <p>{{ user.name }}</p>
                <small>{{ user.persona }}</small>
            </div>
        </div>
        <ul class="vxdash-ul-nav">
            <li class="vxdash-ul-nav-header">Main Navigation</li>
            <li class="vxdash-treeview" v-if="false">
                <a href="javascript:;">
                  <div>
                    <div v-html="icons.dashboard"></div> 
                  </div>
                  <svg width="40px" height="18px" viewBox="0 0 15 15" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z" fill="#ffffff"/>
                  </svg>
                </a>
                <ul class="vxdash-sub">
                    <li>
                      <a href="myschool.php">
                        <div>
                          <div v-html="icons.dashboard"></div> My School
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="myschool.php">
                        <div>
                          <div v-html="icons.dashboard"></div> Test Sub
                        </div>
                      </a>
                    </li>
                </ul>
            </li>
            <li v-if="false">
              <a href="gjb.php">
                <div>
                  <div v-html="icons.dashboard"></div> Your Jobs 
                </div>
                <small class="label pull-right bg-green">new</small>
              </a>
            </li>
            <li>
              <router-link :to="{name:'home'}" exact>
                <div>
                  <div v-html="icons.dashboard"></div> Dashboard
                </div>
              </router-link>
            </li>
            <li v-if="user.persona == 'Admin'">
              <router-link :to="{name:'academicYear'}" exact>
                <div>
                  <div v-html="icons.dashboard"></div> Academic Year
                </div>
              </router-link>
            </li>
            <li>
              <router-link :to="{name:'testmanager'}" exact>
                <div>
                  <div v-html="icons.dashboard"></div> Test Manager
                </div>
              </router-link>
            </li>
            <li v-if="user.persona == 'Admin'">
              <router-link :to="{name:'teacherslist'}" exact>
                <div>
                  <div v-html="icons.dashboard"></div> Teachers
                </div>
              </router-link>
            </li>
            <li v-if="user.persona != 'Student'">
              <router-link :to="{name:'subjectlist'}" exact>
                <div>
                  <div v-html="icons.dashboard"></div> Manage Subject
                </div>
              </router-link>
            </li>
            <li v-if="user.persona == 'Admin'">
              <router-link :to="{name:'students'}" exact>
                <div>
                  <div v-html="icons.dashboard"></div> Students
                </div>
              </router-link>
            </li>
            <li v-if="user.persona == 'Admin'">
              <router-link :to="{name:'quizmanager'}" exact>
                <div>
                  <div v-html="icons.dashboard"></div> Quiz Manager
                </div>
              </router-link>
            </li>
            <li>
              <router-link :to="{name:'settings'}" exact>
                <div>
                  <div v-html="icons.dashboard"></div> Settings
                </div>
              </router-link>
            </li>
            <li>
              <a @click="logout">
                <div>
                  <div v-html="icons.dashboard"></div> Sign Out
                </div>
              </a>
            </li>
        </ul>
    </section>
</div>
</template>

<script>
import { reactive, ref, onMounted,computed,watch } from 'vue';
import icons from '@/assets/js/icons.js';
import { useStore } from 'vuex';
import { urls } from "../assets/js/urls";
import { useRoute } from 'vue-router'
// import Datepicker from 'vue3-datepicker'

export default {
  name: 'DashboardView',
  emits: ['change'],
  setup(props, ctx){
    const route = useRoute()
    const store= useStore();
    const user = computed(() => store.state.User.user);
    const svgIcons = ref(icons);
    const state=reactive({mobile:false});
    if(window.innerWidth < 801){
      state.mobile=true;
      ctx.emit("change",state.mobile)
    }
    watch(
      () => route.fullPath, // or route.path, or route.name
      () => {
        if(window.innerWidth < 801){
            state.mobile=true;
            ctx.emit("change",state.mobile)
        }
      }
    )

    function changeState(){
      state.mobile=state.mobile ? false : true;
      ctx.emit("change",state.mobile)
    }

    onMounted(()=>{
      var tree=document.querySelectorAll(".vxdash-treeview");
      for (let index = 0; index < tree.length; index++) {
        const element = tree[index];
        element.addEventListener("click",()=>{
          element.classList.toggle("active");
        })
      }

    })
    
    function logout(){
        window.location=urls.logout;
      }

    return{state,changeState,icons: svgIcons.value,user, logout}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.glb_nav_top{background: var(--white-color); width:100%; height:var(--top-nav-height); box-shadow: var(--top-nav-box-shadow); display:flex; align-items:center;
z-index: 10; position:fixed;justify-content: space-between;}
.glb_nav_lft{width:var(--left-side-width)}
.glb_nav_ryt{padding-right:40px;}
.glb_nav_lg{padding-left: 24px; padding-right: 24px;}
.glb_lnk_lg{display:flex; align-items: center; text-decoration: none; color:var(--black)}
.glb_lnk_lg img{width:50px}
.glb_lnk_lg h2{margin-left:10px; font-family: poppinss; font-size: 23px;}
.glb_syd_nav{flex-basis: var(--left-side-width); flex-grow: 0; flex-shrink: 0;
  border-right: 1px solid rgb(215, 219, 236);}
.glb_syd_nav_in{padding: 24px;}
.syd_nav_lnk{font-family: inter; -webkit-tap-highlight-color: transparent; outline: 0px; border: 0px; margin: 0px 0px 0.125rem;
  cursor: pointer; user-select: none; vertical-align: middle; appearance: none; display: flex;-webkit-box-flex: 1;
  flex-grow: 1; -webkit-box-pack: start; justify-content: flex-start; -webkit-box-align: center;
  align-items: center; position: relative; text-decoration: none; min-width: 0px; box-sizing: border-box;text-align: left;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  white-space: nowrap; padding: 12px 10px; border-radius: 8px;
  background-color: inherit; color: rgb(90, 96, 127);}
.syd_nav_svg{width:24px; height:24px}
.syd_nav_lnk_dv{display: flex; align-items: center;}
.syd_nav_lnk_dv span{margin-left:10px}
.glb_syd_nav .router-link-active{background: var(--primary-color); color: var(--white-color); fill: var(--white-color);}
.glb_body{display:flex; top: var(--top-nav-height); position:relative; min-height: 600px;}
.glb-cnt{padding: 24px; flex-basis:90%; flex-basis: min(90%, 745px);  flex-grow: 0; flex-shrink: 0;}


.mmm{display:none}
.mobile .glb_syd_nav{flex-basis: 0; overflow: hidden;}
.mobile .glb-cnt{padding: 24px 0; flex-basis: 90%; margin: 0 auto;}

@media (max-width: 800px){
  .glb_body{overflow:hidden}
  .mmm{display:block}
}
</style>
